import api from '../../../../libs/api';
import { gridHelper } from '../../../../libs/grid';
import configQueryReactSimpleRequest from '../../config/configQuery';

import { FieldMapping } from '../../../../libs/grid/gridHelper';
import moment from 'moment';
import { State } from '@progress/kendo-data-query';
import { useGridV2, useServerGridDataHandler } from '../../../../Hooks/useKendoGrid';

const fieldMapping: FieldMapping[] = [
    { frontFieldName: 'workspaceName', backFieldName: 'f.WorkspaceName' },
    { frontFieldName: 'folderId', backFieldName: 'f.FolderId' },
    { frontFieldName: 'folderName', backFieldName: 'f.FolderName' },
    { frontFieldName: 'fullPath', backFieldName: 'f.FullPath' },
    { frontFieldName: 'lastSyncData', backFieldName: 'f.LastSyncData' }
];

const fetchFolders = (gridState: any) =>
    api.post('/api/v2/AsiteRelaticsSync/GetConfigurationFolders', {
        safe: true,
        params: { },
        data: gridHelper.getRequestPayloadFromQueryState(gridState, fieldMapping)
    });

const useConfigurationFoldersGrid = (gridState: State, setGridState: React.Dispatch<React.SetStateAction<State>>) => {
    const {  gridResult, gridQuery } = useGridV2({
        query: {
            queryKey: [],
            queryFn: fetchFolders,
            queryOptions: configQueryReactSimpleRequest,
        },
        transform: (item: any) => ({
            ...item,
            lastSyncData: item.lastSyncData ? new Date(item.lastSyncData) : '',
            createdOn: moment(item.createdOn).format("DD/MM/yyyy HH:mm:ss"),
            updatedOn: moment(item.updatedOn).format("DD/MM/yyyy HH:mm:ss"),
        }),
        gridState,
        setGridState
    });

    const handleDataStateChange = useServerGridDataHandler({ gridState, setGridState, gridQuery });
    
    return { ConfigurationFoldersQuery: gridQuery, gridState, gridResult, handleDataStateChange };
};

export default useConfigurationFoldersGrid;
